"use strict";

var _ = require('underscore');

var DELIMITER1 = '|';
var DELIMITER2 = ';';
var DELIMITER3 = '^';
var DELIMITER4 = '%';
var EQUALS = '~';
var optionsMap = {
    defaultParam : 'd',
    filterQuery : 'f',
    multiSelect : 'm',
    excludeFacet : 'e',
    excludeFromAll : 'a',
    min : 'n',
    max : 'x'
};
var groupOptionsMap = {
    typeOr : 'o',
    multiRestricted : 'r'
};
var encodingOptsMap = {
    options : 'o',
    groups : 'g',
    displayName : 'd'
};

var Serialize = module.exports = {};

Serialize.serializeParams = function (paramsArray) {
    // loop over the params, each key is key, each val is val,
    // options get compressed to 1 character
    // do something about special characters in the display name. Da-Derp?
    var out = [];
    var outStr = '';

    _.each(paramsArray, function (param) {

        var curr = {};
        var options = param.options;
        var groups = options ? options.groups : [];
        var optStr = '';
        var groupArr = [];
        var groupStr = '';
        var displayName;
        var currStr;

        curr.key = param.key;
        curr.val = param.val;

        // If the param includes any options
        if (options && _.size(options)) {

            //Loop over the options, for each one if it is set to true, add it to the options.
            // If the options is the display name it will be a string so store separately.
            _.each(options, function (val, key) {
                if (val === true) {
                    optStr += optionsMap[key];
                } else if (key === 'displayName') {
                    displayName = val;
                }
            }, this);
        }

        curr.options = optStr;

        // If the param includes any groups :
        if (groups && _.size(groups)) {

            // Loop over the groups in the optios. For each collect the name and typeOr option and store as a string.
            // Then join together all of them
            _.each(groups, function (groupObj) {
                // TODO!!! LOOP OVER GROUP OPTIONS MAP IN HERE INSTEAD OF JUST GETTIGN TYPE OR (if necessary in future)
                groupArr.push(groupObj.name + DELIMITER3 + (groupObj.typeOr ? 'o' : '') + (groupObj.multiRestricted ? (DELIMITER3 + groupOptionsMap.multiRestricted) : ''));
            }, this);
            groupStr = groupArr.join(DELIMITER4);
        }

        // Move the groups info and the display name info up to the top level :
        curr.displayName = displayName;
        curr.groups = groupStr;

        // Now that the initial current object is built, use it to create the final serialized string :
        currStr = curr.key + EQUALS + curr.val;
        _.each(encodingOptsMap, function (name, lettr) {
            if (!_.isUndefined(curr[lettr]) && _.size(curr[lettr])) {
                currStr += DELIMITER1;
                currStr += name + EQUALS + curr[lettr];
            }
        }, this);

        out.push(currStr);


    }, this);

    outStr = out.join(DELIMITER2);

    // TODO !!! Using encode uri component on the individual names?
    return outStr;
};



Serialize.deSerializeParams = function (qs) {
    var out = [];
    var arr = qs.split(DELIMITER2);
    // Since we are doing the reverse lookup, we use the inverted versions of the above maps :
    var encodingOptsInverted = _.invert(encodingOptsMap);
    var groupOptionsInverted = _.invert(groupOptionsMap);
    var optionsInverted = _.invert(optionsMap);

    // The starting array splits apart the encoded options by the main delimiter (DEL2). Loop over each getting the
    // key and val for each. The val will either be complex (like group), true / false (like "m") or a string name.
    _.each(arr, function (str1) {
        if (!str1) {
            return;
        }
        var param = {};
        var currArr = str1.split(DELIMITER1);
        var keyVal = currArr.shift().split(EQUALS);
        var optsArr;
        var groupArr;
        var groups = [];

        // Get the key and value (always occurrs at the beginning of the string) :
        param.key = keyVal[0];
        param.val = keyVal[1];

        // Loop over the option strings. For each get the property name and the value. Eg. o=em gets {options : 'em'}
        _.each(currArr, function (str2) {
            var valueArr = str2.split(EQUALS);
            var propName = encodingOptsInverted[valueArr[0]];
            param[propName] = valueArr[1];
        }, this);

        // Now for options and group options, we need to map each character to it's meaning.
        // Eg. o=em means excludeFacet, multiSelect
        if (param.options) {
            optsArr = param.options.split('');
            param.options = {};
            _.each(optsArr, function (lettr) {
                var prop = optionsInverted[lettr];
                param.options[prop] = true;
            }, this);
        }

        // Now we are going to get the groups and the displayName. For each we need the options object to be there
        // so create an empty one if there is not already one there :
        param.options = param.options || {};

        // Now if the param has groups specified, loop over each encoded one and derive a group object :
        if (param.groups) {
            groupArr = param.groups.split(DELIMITER4);
            delete param.groups;
            _.each(groupArr, function (str) {
                var group = {};
                var valArr = str.split(DELIMITER3);
                group.name = valArr.shift();
                _.each(valArr, function (letter) {
                    var prop = groupOptionsInverted[letter];
                    group[prop] = true;
                });
                groups.push(group);
            });
            param.options.groups = groups;
        }

        // The display is on the top level, nest it under the options object.
        if (param.displayName) {
            param.options.displayName = param.displayName;
            delete param.displayName;
        }

        out.push(param);

    }, this);

    return out;
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/solrParamsSerialize.js
// module id = 2622
// module chunks = 62